import moment from 'moment';

const STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}

export function createRequestCards(requests) {

    let cards = []

    requests.sort((a, b) => {
        const aDate = moment(a.datetimeCreated)
        const bDate = moment(b.datetimeCreated)

        return bDate.diff(aDate)
    })
    .forEach(request => {
        cards.push({
            id: request.id,
            job: {
                name: request.job.name
            },
            dateRequested: moment(request.datetimeCreated).format("MM/DD/YYYY"),
            status: STATUS_CHOICES[request.status],
            numItems: request.equipmentRequestItemsForEquipmentRequest.length
        })
    })

    return cards
}